export default function OfficialStatementSummary() {
  return <section id="ringkasan-sikap-resmi" className="bg-background py-12 md:py-16 lg:py-20 xl:py-24 px-4 md:px-6 lg:px-8">
      <div className="mx-auto max-w-full md:max-w-3xl lg:max-w-4xl">
        <div className="bg-muted/30 border-l-primary shadow-sm rounded-r-md border-l-4 px-6 py-6 md:px-8 md:py-8 lg:px-10 lg:py-10">
          <p className="text-foreground font-sans text-base md:text-lg lg:text-xl leading-relaxed font-semibold">
            Pernyataan resmi ini diterbitkan untuk meluruskan berbagai
            misinformasi yang beredar di ruang publik terkait isu terkini. Kami
            menegaskan bahwa seluruh tindakan dan kebijakan yang diambil telah
            sepenuhnya mematuhi prosedur hukum serta standar etika yang berlaku.
            Transparansi dan akuntabilitas akan terus menjadi landasan utama
            kami dalam memberikan informasi yang akurat kepada masyarakat.
          </p>
        </div>
      </div>
    </section>;
}